import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Cari / tedarikçi seçici (arama + liste)
export function PartyPicker({ value, onChange, testid, kinds = ["customer"] }) {
  const [kind, setKind] = useState(value?.kind || kinds[0]);
  const [q, setQ] = useState("");
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => {
      const url = kind === "customer" ? "/customers" : "/suppliers";
      api.get(url, { params: { q, search: q, page_size: 20 } }).then(({ data }) => setOpts((data.items || data).slice(0, 20))).catch(() => setOpts([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q, kind]);
  return (
    <div className="space-y-1">
      <div className="flex gap-1">
        {kinds.length > 1 && <select className="h-9 border rounded text-[13px]" value={kind} onChange={(e) => { setKind(e.target.value); onChange(null); }} data-testid={`${testid}-kind`}>
          <option value="customer">Cari</option><option value="supplier">Tedarikçi</option></select>}
        <input className="h-9 border rounded px-2 text-[13px] flex-1" placeholder="Kod / ünvan ara" value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testid}-search`} />
      </div>
      <select className="h-9 border rounded text-[13px] w-full" value={value?.id || ""} data-testid={`${testid}-select`}
        onChange={(e) => { const o = opts.find((x) => x.id === e.target.value); onChange(o ? { kind, id: o.id, label: `${o.code} – ${o.title || o.name}`, balance: o.balance } : null); }}>
        <option value="">Seçin…</option>
        {value && !opts.some((o) => o.id === value.id) && <option value={value.id}>{value.label}</option>}
        {opts.map((o) => <option key={o.id} value={o.id}>{o.code} – {o.title || o.name} · bakiye {Number(o.balance || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 })}</option>)}
      </select>
    </div>
  );
}
